<template>
  <div class="auditlog comment">
    <el-scrollbar class="auditlog_el">
      <div
        class="each_auditlog_log"
        v-for='item in commentList'
      >
        <div class="each_auditlog_time">{{item.time_create | formatTime}}</div>
        <div
          class="audit_log_person"
          v-if='item.ctrl && item.ctrl.comment_user'
        >
          <img
            :src="item.ctrl.comment_user.headimg"
            alt=""
            v-if='item.ctrl.comment_user.headimg'
          >
          <img
            src="../../../static/img/avatar.png"
            alt=""
            v-if='!item.ctrl.comment_user.headimg'
          >
          <span class="name">{{item.ctrl.comment_user.username}}</span>
        </div>
        <div
          class="audit_log_send"
          v-if="item.comment"
        >
          <span class="send_title">{{item.comment}}</span>
        </div>

        <div
          class="audit_log_send"
          v-if="item.voice"
        >
          <audio
            id="audio"
            ref="audio"
            controls="controls"
            preload
            :src="item.voice"
          >
            <source type="audio/ogg">
            <source type="audio/mpeg">
          </audio>
        </div>

      </div>
    </el-scrollbar>
    <div class="comment_input">
      <el-input
        v-model="commentInput"
        placeholder="请输入评论内容"
        @keyup.enter.native="addComment()"
      ></el-input>
      <el-button
        type="info"
        style="margin-left:20px;background:#688EFF;"
        @click.native='addComment()'
      >发送</el-button>
    </div>
  </div>
</template>

<script>
import { getUrlCode } from '../../../utils/index.js'
import * as api from '../../../api'
export default {
  name: 'comment',
  data () {
    return {
      commentInput: '',
    }
  },
  created () {

  },
  components: {

  },
  computed: {
    commentList () {
      return this.$store.state.logs.commentList
    }
  },
  mounted () {


  },
  destroyed () {

  },
  methods: {
    addComment () {
      if (this.commentInput) {
        var option = {
          ...this.$store.getters.baseOption,
          "params": {                       // 必须字段： 文章参数
            "id_article": this.$parent.$parent.articleId,           // 必须字段： 文章 ID
            "comment": this.commentInput      // 必须字段： 评论的内容
          }
        }
        var url = _API_ + 'api/article/utils/add_comment'
        api._post(url, option).then((res) => {
          if (res.code === 200) {
            this.$notify.success({
              title: '成功',
              message: '添加评论成功'
            });
            this.commentInput = ''
            this.$parent.$parent.getCommentList(this.$parent.$parent.articleId)
          }

        }).catch((error) => {
          console.log(error)
        })
      }
    }

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='stylus' scoped>
@import '../../../styles/audit_comment.styl'

.comment
  .auditlog_el
    height 90%

  .comment_input
    display flex
    box-sizing border-box
    padding 20px
</style>
